import React from 'react';
import PokerCard from 'app/components/poker/poker_cards/PokerCard';
import {CARDS} from 'app/consts/poker-cards';
import {WinnerInterface} from 'app/store/PokerStore';

const SIGN_POSITION = 0;
const SUIT_POSITION = 2;

export const getCardClass = (code: string, winners: WinnerInterface[], condition = true): string => {
    if (winners?.length > 0 && condition) {
        return winners
            .filter(w => w.winner_index !== null && w.best_hand?.includes(code))
            .map(w => ` p${w.winner_index! + 1}`)
            .join('');
    }

    return '';
};

export const selectCard = (card: string, className = ''): React.ReactElement => {
    const card_strings = card.split('_');
    const sign = card_strings[SIGN_POSITION];
    const suit = card_strings[SUIT_POSITION];

    return <PokerCard sign={CARDS[sign]} suit={suit.toLowerCase()} additionClassName={className} />;
};
